<script>
  import { scaleLinear } from "d3-scale";
  import CATEGORY_MAP from "../categories";
  const BLOCK_WIDTH = 23;
  export let category;
  export let label = category;
  export let y;
  export let textAnchor;
  const width = CATEGORY_MAP.length * BLOCK_WIDTH;
  const widthScale = scaleLinear().domain([0, CATEGORY_MAP.length]).range([0, width]);
  const catIndex = CATEGORY_MAP.findIndex((cat) => cat.category === category);

  const x = widthScale(catIndex);
</script>

<text class="cna-legend__label" {x} {y} text-anchor={textAnchor}>{label}</text>

<style>
  .cna-legend__label {
    font: 0.85rem sans-serif;
    text-transform: uppercase;
    fill: #7f7f7f;
  }
</style>
